import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { delay, takeUntil, tap } from 'rxjs/operators';
import { fadeAnimation } from '../../animations/fade.animation';
import { ToastDetails, ToastService, ToastSeverity } from '../../services';

const TOAST_LIFETIME = 3000;

@Component({
  selector: 'hfc-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  animations: [fadeAnimation]
})
export class ToastComponent implements OnDestroy {
  public severity: ToastSeverity;
  public toastDetails: ToastDetails | null = null;

  private readonly iconPaths: Record<ToastSeverity, string | null> = {
    error: '/assets/icons/svg/error-icon.svg',
    info: null,
    success: '/assets/icons/svg/success-icon.svg'
  };

  private destroy$ = new Subject();

  constructor(private toastService: ToastService) {
    this.toastService.message$
      .pipe(
        takeUntil(this.destroy$),
        tap(([toastDetail, severity]) => {
          this.toastDetails = { header: toastDetail.header, message: toastDetail.message };
          this.severity = severity;
        }),
        delay(TOAST_LIFETIME),
        tap(() => (this.toastDetails = null))
      )
      .subscribe();
  }

  public getIconPath(): string | null {
    return this.iconPaths[this.severity] ?? null;
  }

  public onClose() {
    this.toastDetails = null;
  }

  public ngOnDestroy() {
    this.destroy$.next();
  }
}
